// extracted by mini-css-extract-plugin
module.exports = {"card_container":"style_card_container__33xoB","name":"style_name__3-9_w","role":"style_role__2S5wK"};